import styled, { css } from 'styled-components'

import Div from 'ui/elements/Div'

export const Handwriting = styled(Div)`
  font-family: ${({ theme }) => theme.font.handwriting};

  z-index: 27;
  position: absolute;

  ${({ width }) => width && css`
    width: ${width}px;
  `}

  ${({ top }) => top && css`
    top: ${top};
  `}

  ${({ bottom }) => bottom && css`
    bottom: ${bottom};
  `}

  ${({ left }) => left && css`
    left: ${left};
  `}

  ${({ right }) => right && css`
    right: ${right};
  `}

  ${({ rotate = 0 }) => css`
    --rotate: ${rotate}deg;
  `}

  ${({ translateX = 0 }) => css`
    --translate-x: ${translateX};
  `}

  ${({ translateY = 0 }) => css`
    --translate-y: ${translateY};
  `}

  transform: translate(var(--translate-x), var(--translate-y)) rotate(var(--rotate));
`
